export const viewReferralNote_style = {};
